import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../api/api';

import '../layout/sass/_form.scss';

export const FormCotacao = ({ isEditing, isLoading: globalLoading, cotacaoId, defaultValues }) => {
    const toast = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [produtoresLojistas, setProdutoresLojistas] = useState([]);
    const history = useHistory();
    const [cotacaoItens, setCotacaoItens] = useState([]);

    const getProdutoresLojistas = useCallback(async () => {
        setIsLoading(true);
        setProdutoresLojistas([]);
        try {
            const response = await api.get('pessoa/cotacoes');
            console.log(response);
            setProdutoresLojistas(response.data.map(pl => ({
                id: pl.id,
                nome: pl.nome,
                tipoDescricao: pl.tipoDescricao
            })));
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro ao obter pessoas',
                detail: error.toString()
            });
        }
        setIsLoading(false);
    }, []);

    const getCotacaoItens = useCallback(async (cotacaoId) => {
        if (!cotacaoId) return;
        setIsLoading(true);
        try {
            const response = await api.get(`/cotacao/${cotacaoId}`);
            setCotacaoItens(response.data.itens);
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro ao obter itens da cotação',
                detail: error.toString(),
            });
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        getProdutoresLojistas();
        if (isEditing && cotacaoId) {
            getCotacaoItens(cotacaoId);
        }
    }, [getProdutoresLojistas, getCotacaoItens, cotacaoId, isEditing]);

    const handlePessoaChange = (e) => {
        formik.setFieldValue("pessoaId", e.value);
    };

    const schema = Yup.object().shape({
        pessoaId: Yup.number().required("A pessoa é obrigatória").positive().integer(),
        ativo: Yup.boolean()
    });

    const formik = useFormik({
        initialValues: {
            pessoaId: defaultValues?.pessoaId || '',
            ativo: defaultValues?.ativo || false
        },
        validationSchema: schema,
        onSubmit: async (data) => {
            setIsSubmitting(true);
            try {
                if (isEditing) {
                    await api.put(`/cotacao`, data);
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Cotação atualizada!' });
                    setTimeout(() => {
                        history.push('/cotacao')
                    }, 2000)
                } else {
                    await api.post('/cotacao', data);
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Cotação criada!' });
                    formik.resetForm();
                    setTimeout(() => {
                        history.push('/cotacao')
                    }, 2000)
                }
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar a cotação.' });
            }
            setIsSubmitting(false);
        }
    });

    useEffect(() => {
        if (defaultValues) {
            formik.setValues(defaultValues);
        }
    }, [defaultValues]);

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} />
            <div className='p-col-12'>
                <h2 className="p-mt-0">Cotação</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0 p-d-flex p-ai-center">
                        <div className="p-field p-col-12 p-sm-6">
                            <label htmlFor="pessoa">Produtor / Lojista</label>
                            {!isLoading ? (
                               <Dropdown
                                   id="pessoaId"
                                   name="pessoaId"
                                   options={produtoresLojistas}
                                   filter
                                   emptyMessage="Nenhum produtor/lojista encontrado"
                                   optionLabel={(item) => `${item.nome} - ${item.tipoDescricao}`}
                                   optionValue="id"
                                   placeholder="Selecione um produtor/lojista"
                                   value={formik.values.pessoaId}
                                   onChange={handlePessoaChange}
                                   className={formik.touched.pessoaId && formik.errors.pessoaId ? 'p-invalid' : ''}
                               />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.touched.pessoaId && formik.errors.pessoaId && <small className="p-error">{formik.errors.pessoaId}</small>}
                        </div>

                        <div className="p-field p-col-12 p-sm-3 p-d-flex p-ai-center">
                            <label htmlFor="ativo" className="p-mr-2">Ativo</label>
                            <Checkbox
                                id="ativo"
                                name="ativo"
                                checked={formik.values.ativo}
                                onChange={(e) => formik.setFieldValue("ativo", e.checked)}
                            />
                            {formik.touched.ativo && formik.errors.ativo && (
                                <small className="p-error p-ml-2">{formik.errors.ativo}</small>
                            )}
                        </div>

                        <Button
                            label={isEditing ? 'Atualizar' : 'Criar'}
                            type="submit"
                            loading={isSubmitting}
                            disabled={globalLoading}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};
